module.exports = __webpack_public_path__ + "img/Lianli_Gao@2x.fe60e665.png";